import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson3: FunctionComponent = () => {
  return (
    <div className="relative bg-gray-100 w-full overflow-hidden flex flex-col items-center justify-center p-[2.69rem] box-border gap-[6.88rem] text-center text-[1.56rem] text-darkgray font-nunito">
      <NAV dimensionCode="/nav@2x.png" navIconFlexShrink="unset" />
      <div className="self-stretch flex flex-row items-center justify-between text-left">
      <a className="cursor-pointer text-darkgray no-underline" href={"/lesson2"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Back
          </b>
        </div>
        </a>
        <div className="self-stretch flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[100%]">
            Positive Changes
          </b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson4"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Next
          </b>
        </div>
        </a>
      </div>
      <div className="self-stretch flex flex-col items-center justify-center gap-[6.25rem] text-[2.19rem] text-white font-dm-sans">
        <b className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          Steps to Making Positive Change
        </b>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-gainsboro-100 text-justify text-[1.56rem]">
          <p className="m-0">
            Neuro-associative conditioning is an automatic process that develops
            automatically without your conscious involvement. But you can
            therefore consciously use it as an effective method of reprogramming
            your conditioning. These are the steps that can lead to consistent
            and lasting behavioral change:
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="text-[1.88rem] font-dm-sans">Step 1</b>
            <span>
              {" "}
              - Determine first what you really want and what is stopping you
              from doing it now
            </span>
          </p>
          <p className="m-0">
            Do an analysis of your self-image. Why do you do what you do and
            what is it based on? Then determine what you want. This should be so
            crystal clear that you can easily draw it out. Clarity is essential
            to achieving your goals. Next, you need to find out what is holding
            you back from achieving what you want so that you can systematically
            overcome those obstacles.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="text-[1.88rem] font-dm-sans">Step 2</b>
            <span> - Make your 'want to' a 'have to'</span>
          </p>
          <p className="m-0">
            Think of one thing you would like to change about yourself, your
            behaviour, or your current situation. Make up your mind that you
            really want to change and are going to. Think of all the pain you
            could attach to your old behaviour if you don't change and what
            adverse consequences this will have for your life and your sense of
            happiness. start with the most dramatic consequence. Then think
            about what pleasurable feelings you can link to what you are going
            to change. Is this change a must for you? So? What are you going to
            do?
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="text-[1.88rem] font-dm-sans">Step 3</b>
            <span> - Break through your obstructive patterns</span>
          </p>
          <p className="m-0">
            Without a plan and without discipline, it is just an intention, a
            good intention. So don't say: quitting smoking will make you snack
            and get fat. Well: living a healthy life makes my skin look more
            beautiful and attractive, I feel much more vital and have more
            energy. Learning a new pattern or new behaviour only works if your
            desired new pattern is linked to a concrete plan, self-discipline, a
            positive effect, and a reward.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="text-[1.88rem] font-dm-sans">Step 4</b>
            <span> - Reconditioning</span>
          </p>
          <p className="m-0">
            You will have to consciously apply the new pattern each time and
            keep repeating it, only then will it become automatic. Be aware of
            your behaviour and reward yourself every time you make a positive
            change.
          </p>
          <p className="m-0">
            Don't underestimate the power of conditioning. It may take some time
            to replace a thought pattern, but once your new pattern is
            conditioned, you won't want to go back to your old, negative pattern
            any time soon. This way, you can eventually become the best version
            of yourself, the person you wish to be.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="text-[1.88rem] font-dm-sans">Step 5</b>
            <span> - Check your new behaviour for a lasting effect</span>
          </p>
          <p className="m-0">&nbsp;</p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                Ask yourself: do I feel miserable when I think about my old
                behaviour? Make sure you link - in your mind - intense pain to
                your old behaviour.
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                Determine whether your new behaviour is linked to pleasure and
                satisfaction so that it makes you feel good.
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                Ask yourself if your new behaviour is in line with your personal
                values and beliefs. does it align with who you want to be? If it
                does not, you will need to revisit whether you have formulated
                your personal values correctly. If your personal values are
                correct, re-examine why your behaviour is not in harmony with
                who you 'say' you want to be.
              </span>
            </li>
            <li>
              <span>
                Check whether you are convinced that your new behaviour will
                only bring long-term benefits in terms of quality of life and
                well-being. And if not? How do you make sure it does?
              </span>
            </li>
          </ul>
        </div>
        <img
          className="relative w-[79.38rem] h-[43rem] object-cover"
          alt=""
          src="/3@2x.png"
        />
      </div>
      <a className="cursor-pointer text-darkgray no-underline" href={"/lesson4"}>
        <div className="rounded-32xl bg-gainsboro-200 box-border w-[25rem] flex flex-col items-center justify-center pt-[0.69rem] px-[3rem] pb-[1rem] max-w-[31.25rem] text-center text-[1.88rem] border-[1px] border-solid border-gray-300">
          <b className="self-stretch relative">Next Chapter</b>
        </div>
      </a>
    </div>
  );
};

export default Lesson3;
